import { useModalContentToggler } from '@components'

import { Button, ButtonsGroup } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useShineConnectModal } from '../../contexts/shineConnectModalContext'
import { CreateBankConnectionModalSteps } from '../../enums/createBankConnectionModalSteps'

export const ConfirmationModalFooter = (): ReactElement => {
  const { t } = useTranslation()
  const { handleCloseModal, handleMergeAccounts } = useShineConnectModal()
  const { setActiveState } = useModalContentToggler()

  const handleConfirmButtonClick = useCallback(() => {
    setActiveState(CreateBankConnectionModalSteps.Processing)
    handleMergeAccounts()
  }, [handleMergeAccounts, setActiveState])

  return (
    <ButtonsGroup>
      <Button variant="outlined" onClick={handleCloseModal}>
        {t('cancel')}
      </Button>
      <Button variant="filled" onClick={handleConfirmButtonClick}>
        {t('bank_connection.shine_connect_modal.confirm_button')}
      </Button>
    </ButtonsGroup>
  )
}
